import {createRequestTypes} from '../utils/helpers';

export const INITIALIZE = createRequestTypes('@camvio-wizard/INITIALIZE');
export const REGISTER_STEP = createRequestTypes('@camvio-wizard/REGISTER_STEP');
export const PREVIOUS_STEP = createRequestTypes('@camvio-wizard/PREVIOUS_STEP');
export const NEXT_STEP = createRequestTypes('@camvio-wizard/NEXT_STEP');
export const DESTROY = createRequestTypes('@camvio-wizard/DESTROY');
export const SET_STEP_STATE = createRequestTypes('@camvio-wizard/SET_STEP_STATE');